import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatSnackBarService } from '@ib-core/services/snackbar.service';
import { AuthFacadeService } from '@ib-core-services/auth-facade.service';
import { NavigationService } from '@ib-core-services/navigation.service';
import { IB_ROUTES } from '@ib-enums/routes.enum';

@Component({
  selector: 'ib-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public form: FormGroup;
  public loading = false;
  // public FORGOT_PASSW_ROUTE = NavigationService.getRouteSegmentsByRoute(
  //   IB_ROUTES.FORGOT_PASSWORD,
  // );

  public FORGOT_PASSW_ROUTE = '/forgot-password';
  @ViewChild('emailInput') emailInput: ElementRef<HTMLInputElement>;

  constructor(
    private fb: FormBuilder,
    private authFacadeS: AuthFacadeService,
    private navS: NavigationService,
    private snackbar: MatSnackBarService,
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.emailInput?.nativeElement?.focus();
    }, 500);
    this.form = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  submitFromInput(e): void {
    e.stopPropagation();
    e.preventDefault();
    if (this.form.valid) {
      this.login();
    } else {
      this.form.markAllAsTouched();
    }
  }

  signUp(): void {
    this.navS.goToRoute(IB_ROUTES.SIGN_UP);
  }

  login(): void {
    this.loading = true;
    this.authFacadeS
      .login({
        email: this.form.get('email').value,
        password: this.form.get('password').value,
      })
      .subscribe({
        next: () => {
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }
}
